import React, { useCallback, useContext } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import TextButton from 'components/Luxkit/Button/TextButton'
import { isLoggedIn } from 'selectors/accountSelectors'
import { PrimaryNotificationDot } from 'tripPlanner/components/NotificationDot'
import LineHeartIcon from 'components/Luxkit/Icons/line/LineHeartIcon'
import zIndex from 'styles/tools/z-index'
import SavedDrawer from 'tripPlanner/components/Drawer/SavedDrawer'
import ModalContext from 'contexts/ModalContext'
import usePendingLoginHandler from 'hooks/usePendingLoginHandler'

const MenuItem = styled.div`
  position: relative;
  z-index: ${zIndex.menu};
`

const TextWithNotification = styled.div`
  position: relative;
`

const MyTripNotificationDot = styled(PrimaryNotificationDot)`
  position: absolute;
  top: 0;
  left: 100%;
`

interface Props {
  isLoggedIn: boolean;
  showTripNotificationDot: boolean;
}

function NavigationHeaderTripsMenu({ isLoggedIn, showTripNotificationDot }: Props) {
  const showModal = useContext(ModalContext)
  const openModal = useCallback(() => {
    showModal(<SavedDrawer/>)
  }, [showModal])
  const onClick = usePendingLoginHandler(openModal, 'tripPlannerLogin')

  return <MenuItem>
    <TextButton
      kind="tertiary"
      variant="dark"
      startIcon={<LineHeartIcon size="XS" />}
      onClick={onClick}
    >
      <TextWithNotification>Saved{showTripNotificationDot && <MyTripNotificationDot />}</TextWithNotification>
    </TextButton>
    { isLoggedIn && <SavedDrawer /> }
  </MenuItem>
}

function mapStateToProps(state: App.State) {
  return {
    isLoggedIn: isLoggedIn(state),
    showTripNotificationDot: state.tripPlanner.tripItemHasJustBeenAdded,
  }
}

export default connect(mapStateToProps)(NavigationHeaderTripsMenu)
